import{STOREFRONT_PRICE_FRAGMENT as n}from"./price.js";const r=`\nminVariantPrice {\n  ${n}\n}\nmaxVariantPrice {\n  ${n}\n}\n`;export{r as STOREFRONT_PRICE_RANGE_FRAGMENT};
//# sourceMappingURL=price-range.js.map
